export enum workLogCategory {
  REGULAR = "REGULAR",
  DAY_OFF = "DAY_OFF",
}
